import React from 'react';

import TransactionsReportForm from './TransactionsReportForm';
import BalancesReportForm from './BalancesReportForm';
import InvoiceReportsForm from './InvoiceReportsForm';
import PaymentReportsForm from './PaymentReportsForm';
import SignUpTerminationReportForm from './SignUpTerminationReportForm';

import featureFlags from '../../../featureFlags';


function ReportList({ facilityId }) {
  return (
    <>
      {featureFlags.INVOICE_REPORT_CSV && 
      <>

      <BalancesReportForm facilityId={facilityId} />

      {featureFlags.PAYMENT_REPORTS &&  
      <>
      <PaymentReportsForm facilityId={facilityId} />
      </>
      }

      <InvoiceReportsForm facilityId={facilityId} />

      <SignUpTerminationReportForm facilityId={facilityId} />
      <TransactionsReportForm facilityId={facilityId} />
      
      </>
      }

      {!featureFlags.INVOICE_REPORT_CSV && 
      <>

      <TransactionsReportForm facilityId={facilityId} />
      <BalancesReportForm facilityId={facilityId} />
      <SignUpTerminationReportForm facilityId={facilityId} />
      
      {featureFlags.PAYMENT_REPORTS &&  
      <>
      <PaymentReportsForm facilityId={facilityId} />
      </>
      }

      </>
      }
    </>
  );
}

export default React.memo(ReportList);